import {
  GET_COORDINATION,
  GET_COORDINATION_FAIL,
  GET_COORDINATION_SUCCESS,
  GET_COORDINATIONS,
  GET_COORDINATIONS_FAIL,
  GET_COORDINATIONS_SUCCESS,
  ADD_NEW_COORDINATION,
  ADD_COORDINATION_SUCCESS,
  ADD_COORDINATION_FAIL,
  UPDATE_COORDINATION,
  UPDATE_COORDINATION_SUCCESS,
  UPDATE_COORDINATION_FAIL,
  DELETE_COORDINATION,
  DELETE_COORDINATION_SUCCESS,
  DELETE_COORDINATION_FAIL,
  SET_STATE_COORDINATION,
  UPDATE_COORDINATION_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_COORDINATION,
  payload: loading,
})

export const getCoordinations = ( params ) => ({
  type: GET_COORDINATIONS,
  payload: { params },
})

export const getCoordinationsSuccess = (coordinations,totalPages, currentPage) => ({
  type: GET_COORDINATIONS_SUCCESS,
  payload: {coordinations:coordinations, total:totalPages, currentPage:currentPage}
})

export const getCoordinationsFail = error => ({
  type: GET_COORDINATIONS_FAIL,
  payload: error,
})

export const addNewCoordination = coordination => ({
  type: ADD_NEW_COORDINATION,
  payload: coordination,
})

export const addCoordinationSuccess = coordination => ({
  type: ADD_COORDINATION_SUCCESS,
  payload: coordination,
})  

export const addCoordinationFail = error => ({
  type: ADD_COORDINATION_FAIL,
  payload: error,
})

export const updateCoordination = coordination => ({
  type: UPDATE_COORDINATION,
  payload: coordination,
})

export const updateCoordinationStatus = coordination => ({
  type: UPDATE_COORDINATION_STATUS,
  payload: coordination,
})

export const updateCoordinationSuccess = coordination => ({
  type: UPDATE_COORDINATION_SUCCESS,
  payload: coordination,
})

export const updateCoordinationFail = error => ({
  type: UPDATE_COORDINATION_FAIL,
  payload: error,
})

export const deleteCoordination = coordination => ({
  type: DELETE_COORDINATION,
  payload: coordination,
})

export const deleteCoordinationSuccess = id => ({
  type: DELETE_COORDINATION_SUCCESS,
  id,
})

export const deleteCoordinationFail = error => ({
  type: DELETE_COORDINATION_FAIL,
  payload: error,
})

export const getCoordination = () => ({
  type: GET_COORDINATION,
})

export const getCoordinationSuccess = coordination => ({
  type: GET_COORDINATION_SUCCESS,
  payload: coordination,
})

export const getCoordinationFail = error => ({
  type: GET_COORDINATION_FAIL,
  payload: error,
})
